import type SchedulingPolicy from '../store/schema/SchedulingPolicyBooking';
import type BookingMeetingType from 'owa-service/lib/contract/BookingService';

export default function getMeetingTypeExtensionSchedulingPolicy(
    meetingType: BookingMeetingType
): SchedulingPolicy {
    const schedulingPolicyMeetingTypeExtension: SchedulingPolicy = {
        allowStaffSelection: false,
        capTimeInDays: meetingType.SchedulingPolicy?.EndOfBookingWindowInDays || 90,
        hasCustomServiceWindows:
            meetingType.SchedulingPolicy?.ServiceBookableWindows != null &&
            meetingType.SchedulingPolicy.ServiceBookableWindows.length > 0,
        leadTimeForBookingsInMinutes:
            meetingType.SchedulingPolicy?.LeadTimeForBookingsInMinutes || 60,
        leadTimeForCancellationsInMinutes:
            meetingType.SchedulingPolicy?.LeadTimeForCancellationsInMinutes || 60,
        leadTimeInMinutes: meetingType.SchedulingPolicy?.LeadTimeInMinutes || 60,
        timeSlotIntervalInMinutes: meetingType.SchedulingPolicy?.TimeSlotIntervalInMinutes || 30,
    };
    return schedulingPolicyMeetingTypeExtension;
}
